import React from "react";
import styles from "./index.module.scss";
import clsx from "clsx";
export interface ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  primary?: boolean;
  style?: React.CSSProperties;
}

export const Button: React.FC<ButtonProps> = (props) => {
  const { children, onClick, disabled, primary, className } = props;
  return (
    <button
      
      className={clsx(
        styles.button, 
        primary && styles.primary,
        disabled && styles.disabled,
        className
      )}
      disabled={disabled}
      onClick={onClick}
      style={props.style}
    >
      {children}
    </button>
  );
};
